import React from 'react';
import PropTypes from 'prop-types';
import css from '@src/js/Style';
import Collapse from '../Base/Collapse';
import Translation from '../Base/Translation';
import MenuSecondary from './MenuSecondary';
import MenuPopup from './MenuPopup';

export default class MenuPrimary extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            popup: null,
        };
    }

    static get propTypes() {

        return {
            anchor: PropTypes.string,
            link: PropTypes.string,
            items: PropTypes.any,
        };
    }

    render() {

        const { anchor } = this.props;

        return <Collapse anchor={ anchor }>{ this.renderSecondary() }</Collapse>;
    }

    renderSecondary() {

        const
            { items } = this.props,
            { popup } = this.state;

        return (
            <div className={ css('flex flex-wrap gap') }>
                {
                    Array.isArray(items)
                        ? items.map((item, index) => this.renderSecondaryItem(item, index))
                        : null
                }
                { this.renderLink() }
                { popup }
            </div>
        );
    }

    renderSecondaryItem(item, index) {

        return (
            <div key={ index } className={ css('w-full cursor-pointer select-none') } onClick={ () => this.handleSecondaryClick(item) }>
                { item.anchor }
            </div>
        );
    }

    renderLink() {

        const { link } = this.props;

        if (link == null)
            return null;

        return (
            <a className={ css('flex items-center gap text-primary') } href={ link }>
                <Translation tag='menu.go-to-section' />
                <svg width='7' height='12' viewBox='0 0 7 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fillRule='evenodd' clipRule='evenodd' d='M0.52827 0.861919C0.788619 0.601569 1.21073 0.601569 1.47108 0.861919L6.13775 5.52858C6.3981 5.78893 6.3981 6.21104 6.13775 6.47139L1.47108 11.1381C1.21073 11.3984 0.788619 11.3984 0.52827 11.1381C0.26792 10.8777 0.26792 10.4556 0.52827 10.1953L4.72353 5.99999L0.52827 1.80473C0.26792 1.54438 0.26792 1.12227 0.52827 0.861919Z' fill='#1373E5'/></svg>
            </a>
        );
    }

    renderBackHeader() {

        return (
            <div className={ css('h-full flex items-center justify-between gap pl-2 px-4') }>
                <div className={ css('flex items-center gap-sm text-muted text-medium') } onClick={ () => this.handleClosePopup() }>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M13.0889 3.57739C13.4144 3.90283 13.4144 4.43047 13.0889 4.7559L7.84485 9.99998L13.0889 15.2441C13.4144 15.5695 13.4144 16.0971 13.0889 16.4226C12.7635 16.748 12.2359 16.748 11.9104 16.4226L6.07709 10.5892C5.75165 10.2638 5.75165 9.73616 6.07709 9.41072L11.9104 3.57739C12.2359 3.25195 12.7635 3.25195 13.0889 3.57739Z" fill="#87919C"/></svg>
                    <Translation tag='menu.go-back' />
                </div>
            </div>
        );
    }

    handleClosePopup() {

        this.setState({ popup: null });
    }

    handleCloseMenu() {

        this.setState({ popup: null });
        document
            .querySelector('body > header [data-role="menu-toggler"]')
            ?.click();
    }

    handleSecondaryClick(item) {

        const popup = (
            <MenuPopup header={ this.renderBackHeader() }>
                <MenuSecondary { ...item } />
            </MenuPopup>
        );

        this.setState({ popup });
    }

}